import { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import RootLayout from "./global/RootLayout";
import Homepage from "./scenes/pages/homepage/Homepage";
import About from "./scenes/pages/about/About";
import Process from "./scenes/pages/process/Process";
import { SplineProvider } from "./context/SplineContext";

const routes = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: "/", element: <Homepage /> },
      { path: "/about", element: <About /> },
      { path: "/process", element: <Process /> },
    ],
  },
]);

function App() {
  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     // Blokiraj tastaturni zoom (Cmd/Ctrl + +/-/0)
  //     if ((e.ctrlKey || e.metaKey) && ["+", "-", "=", "0"].includes(e.key)) {
  //       e.preventDefault();
  //     }
  //   };

  //   const handleWheel = (e) => {
  //     // Spreči samo pokušaje zoomiranja pomoću scrolla uz Cmd/Ctrl
  //     const isZoomGesture =
  //       (e.ctrlKey || e.metaKey) &&
  //       (Math.abs(e.deltaY) > 10 || Math.abs(e.deltaX) > 10);

  //     if (isZoomGesture) {
  //       e.preventDefault();
  //     }
  //   };

  //   window.addEventListener("keydown", handleKeyDown);
  //   window.addEventListener("wheel", handleWheel, { passive: false });

  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown);
  //     window.removeEventListener("wheel", handleWheel);
  //   };
  // }, []);
  return (
    <>
      <SplineProvider>
        <RouterProvider router={routes} />
      </SplineProvider>
    </>
  );
}

export default App;
